<div class="mt-5 flex flex-column">
  <div class="text-lg-semibold text-gray-900">Sve rezervacije</div>
  <div class="mt-3 flex flex-column lg:flex-row lg:align-items-center justify-content-between gap-3">
    <p-tabs class="transparent" [value]="0" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab [value]="0">
          <div class="flex align-items-center">
            <app-calendar-check-01 stroke="#7E838F"></app-calendar-check-01>
            <div class="ml-2 text-sm-semibold">Predstojeće</div>
            @if (upcomingCount) {
              <p-badge
                class="ml-2"
                styleClass="upcoming-badge"
                [value]="upcomingCount"
              />
            }
          </div>
        </p-tab>
        <p-tab [value]="1">
          <div class="flex align-items-center">
            <app-clock-rewind stroke="#7E838F"></app-clock-rewind>
            <div class="ml-2 text-sm-semibold">Istorija</div>
          </div>
        </p-tab>
      </p-tablist>
    </p-tabs>
    <div class="search-input">
      <app-text-input
        [hasIcon]="true"
        ctrlPlaceholder="Pretraga"
        formCtrlClass="table-search-input"
        shortcutHint="⌘K"
        [formCtrl]="searchFormCtrl | formControl"
      >
        <app-search stroke="#ADB0B8"></app-search>
      </app-text-input>
    </div>
    <div class="flex flex-column sm:flex-row align-items-stretch sm:align-items-center gap-2">
      <app-client-type-dropdown
        [reset]="resetCounter"
        (onSelect)="onClientTypeChange($event)"
      ></app-client-type-dropdown>
    </div>
  </div>
  @if (hasActiveFilters) {
    <div class="mt-3-5 flex justify-content-end align-items-center">
      <div class="text-sm-semibold text-red-600 cursor-pointer" (click)="resetFilters()">Resetuj filtere</div>
    </div>
  }
  <p-table
    class="mt-3-5"
    [class.is-empty]="!isLoading && appointments.length === 0"
    [value]="appointments"
    [lazy]="true"
    [paginator]="(paginatedData.totalCount ?? 0) > 0"
    [first]="first"
    [rows]="paginatedData.pageSize!"
    [totalRecords]="paginatedData.totalCount!"
    [loading]="isLoading"
    [tableStyleClass]="appointments.length === 0 ? 'hide-header' : ''"
    (onLazyLoad)="loadAppointmentsLazy($event)"
    [showFirstLastIcon]="false"
  >
    <!-- HEADER -->
    <ng-template #header>
      <th>
        <div class="text-xs-semibold text-gray-400 flex px-4 pt-2-5">VREME</div>
      </th>
      <th>
        <div class="text-xs-semibold text-gray-400 flex px-3 header-cell">TRAJANJE</div>
      </th>
      <th>
        <div class="text-xs-semibold text-gray-400 flex px-4 header-cell">KORISNIK</div>
      </th>
      <th>
        <div class="text-xs-semibold text-gray-400 flex px-4 header-cell">PLAN PROJEKCIJE</div>
      </th>
      <th>
        <div class="text-xs-semibold text-gray-400 flex px-4 header-cell">STATUS</div>
      </th>
      @if (activeTab === 0) {
        <th>
          <div class="flex justify-content-end text-xs-semibold text-gray-400 px-6 header-cell">AKCIJE</div>
        </th>
      }
    </ng-template>

    <!-- BODY -->
    <ng-template #body let-appt>
      <tr class="cursor-pointer" (click)="openDetails(appt.id)">
        <td>
          <div class="flex align-items-center gap-2-5 calendar ">
            <div class="date-tile flex flex-column align-items-center">
              <div class="date-tile-month">{{ getMonthLabel(appt.from) }}</div>
              <div class="date-tile-day text-sm-semibold text-gray-900">{{ getDayLabel(appt.from) }}</div>
            </div>
            <div class="flex flex-column gap-1">
              <div class="text-sm-medium text-gray-900">{{ getPrimaryDateLabel(appt.from) }}</div>
              <div class="text-sm-medium text-gray-500">{{ formatTimeRange(appt.from, appt.to) }}</div>
            </div>
          </div>
        </td>
        <td>
          <div class="flex align-items-center gap-1">
            <div class="text-sm-medium text-gray-900">{{ appt.duration }}</div>
            <div class="text-sm-medium text-gray-500">h</div>
          </div>
        </td>
        <td>
          <div class="ml-2-5 flex flex-column gap-1">
            <div class="text-sm-medium text-gray-900">{{ appt.clientEmail }}</div>
            <div class="text-sm-medium text-gray-500">{{ appt.isCompany ? 'Pravno lice' : 'Fizičko lice' }}</div>
          </div>
        </td>
        <td>
          @if (appt.numOfAttachments > 0) {
            <div class="flex align-items-center gap-1">
              <app-attachment-02 stroke="#ADB0B8"></app-attachment-02>
              <div class="text-sm-medium text-gray-900">{{ appt.numOfAttachments }}</div>
            </div>
          } @else {
            <div class="missing-file inline-flex align-items-center gap-1">
              <app-alert-triangle stroke="#DC6803"></app-alert-triangle>
              <div class="text-xs-medium text-gray-700">Nedostaje fajl</div>
            </div>
          }
        </td>
        <td>
          <div class="status-cell">
            <p-chip
              [label]="getStatusLabel(appt)"
              [class]="getStatusChipClass(appt.status.value)"
            >
            </p-chip>
          </div>
        </td>
        @if (activeTab === 0) {
          <td>
            <div class="flex align-items-center justify-content-end gap-2-5">
              @if (!appt.isShortNotice) {
                <app-button btnClass="action-btn" [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.SM"
                            (btnClicked)="openRescheduleDialog(appt.id); $event.stopPropagation()">
                  <app-edit-03 stroke="#181D27" width="15px" height="15px"></app-edit-03>
                </app-button>
              }
              <app-button btnClass="action-btn" [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.SM"
                          (btnClicked)="openCancelDialog(appt.id, appt.clientEmail); $event.stopPropagation()">
                <app-slash-circle-01 stroke="#181D27" width="16px" height="16px"></app-slash-circle-01>
              </app-button>
            </div>
          </td>
        }
      </tr>
    </ng-template>

    <!-- EMPTY STATE -->
    <ng-template #emptymessage>
      <div class="flex justify-content-center align-items-center text-gray-900 text-lg-semibold py-5">
        Nema rezervacija
      </div>
    </ng-template>

    <ng-template #paginatorleft>
      <app-button
        [btnSize]="ButtonSize.SM"
        [btnSeverity]="ButtonSeverity.SECONDARY"
        (btnClicked)="prev()"
        [isBtnDisabled]="!paginatedData.hasPreviousPage"
      >
        <app-arrow direction="left" stroke="#3D3B3A"></app-arrow>
        <div class="paginator-btn-label text-sm-semibold text-gray-700">Nazad</div>
      </app-button>
    </ng-template>

    <ng-template #paginatorright>
      <app-button
        [btnSize]="ButtonSize.SM"
        [btnSeverity]="ButtonSeverity.SECONDARY"
        (btnClicked)="next()"
        [isBtnDisabled]="!paginatedData.hasNextPage"
      >
        <div class="paginator-btn-label text-sm-semibold text-gray-700">Dalje</div>
        <app-arrow direction="right" stroke="#3D3B3A"></app-arrow>
      </app-button>
    </ng-template>

    <ng-template #loadingbody>
      @for (row of [1, 2, 3, 4, 5, 6]; track row) {
        <tr>
          <td>
            <div class="flex align-items-center gap-2">
              <p-skeleton width="2.5rem" height="2.75rem"></p-skeleton>
              <p-skeleton width="6rem"></p-skeleton>
            </div>
          </td>
          <td>
            <p-skeleton width="3rem"></p-skeleton>
          </td>
          <td>
            <div class="flex align-items-center gap-2">
              <p-skeleton shape="circle" size="2rem"></p-skeleton>
              <p-skeleton width="8rem"></p-skeleton>
            </div>
          </td>
          <td>
            <p-skeleton width="4rem"></p-skeleton>
          </td>
          <td>
            <p-skeleton width="5rem" height="1.5rem"></p-skeleton>
          </td>
          @if (activeTab === 0) {
            <td>
              <p-skeleton width="2rem" height="2rem"></p-skeleton>
            </td>
          }
        </tr>
      }
    </ng-template>
  </p-table>
</div>

@if (selectedForCancel()) {
  <p-dialog [(visible)]="showCancelDialog"
            [modal]="true"
            [closable]="false"
            [style]="{ width: '25rem', maxWidth: 'calc(100vw - 2rem)', height: 'auto', minHeight: '16rem' }"
  >
    <div class="flex flex-column">
      <div class="text-lg-semibold text-gray-900">
        Otkažite termin
      </div>
      <div class="mt-1 text-sm-regular text-gray-600">Da li ste sigurni da želite da otkažete termin korisnika {{selectedForCancel()!.name}}?</div>
    </div>
    <ng-template #header>
      <div class="flex align-items-center justify-content-between w-full">
        <div class="flex justify-content-center align-items-center dialog-header-icon">
          <app-slash-circle-01 stroke="#414651" width="20px" height="20px"></app-slash-circle-01>
        </div>
        <app-x-close stroke="#ADB0B8" width="12" height="12" class="cursor-pointer" (click)="closeCancelDialog()"></app-x-close>
      </div>
    </ng-template>
    <ng-template #footer>
      <div class="flex justify-content-end align-items-center w-full">
        <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="closeCancelDialog()">
          <div class="text-sm-semibold text-gray-900">Odustani</div>
        </app-button>
        <app-button class="ml-2-5" [isDestructive]="true" [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="confirmCancel()">
          <div class="text-sm-semibold text-white">Otkaži termin</div>
        </app-button>
      </div>
    </ng-template>
  </p-dialog>
}

<app-appointment-details-drawer
  [(visible)]="showDetailsDrawer"
  [appointmentId]="selectedDetailsId()"
  (onCancel)="onDetailsCancel($event)"
  (onRescheduled)="onRescheduled()"
  (onMarkedNoShow)="onDetailsCancel($event)"
></app-appointment-details-drawer>

<app-appointment-reschedule-dialog
  [(visible)]="showRescheduleDialog"
  [appointmentId]="selectedRescheduleId()"
  (rescheduled)="onRescheduled()"
></app-appointment-reschedule-dialog>
